// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn--1y2uF","active":"active--seh0M"};